import { render, staticRenderFns } from "./Comics.vue?vue&type=template&id=681d75e5&"
import script from "./Comics.vue?vue&type=script&lang=js&"
export * from "./Comics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports